import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Alpine from 'alpinejs/dist/alpine-ie11'
window.Alpine = Alpine

import Feather from 'feather-icons'
window.Feather = Feather

Feather.replace()
